import { empresas } from './config/empresas';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const empresaId = process.env.REACT_APP_COMPANY || 'pontocerto';
const empresa = empresas[empresaId] || empresas['pontocerto'];

export const API_BASE_URL = isLocalhost
  ? 'http://v1-csapi.compsoft.com.br:9123'
  : empresa.apiUrl;
